module.exports = __webpack_public_path__ + "static/media/mailCPanel.bb612d30.svg";